import React, {useCallback, useEffect, useRef} from 'react';
import {Alert, View, Animated} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import Modal from 'react-native-modal';
import {Clipboard} from 'react-native';

import {
  ModalContainer,
  ModalContent,
  CloseModalIconButton,
  CloseIcon,
  ModalBody,
  ModalTitle,
  ModalText,
  ModalFooter,
  CouponContainer,
  CouponContent,
  CouponLeftSide,
  CouponRightSide,
  CouponDiscount,
  CouponMaxValue,
  CouponDescription,
  CouponBrand,
  CouponExpiry,
  PrizeImage,
  ModalBackground,
} from './styles';

import {useTheme} from 'styled-components';
import {RouletteDTO} from '../../../../dtos/RouletteDTO';
import {Button} from '../../../../components/Interface/Forms/Buttons/Button';

interface WinPrizeModalProps {
  isVisible: boolean;
  onClose: () => void;
  rouletteData: RouletteDTO | null;
}

export function WinPrizeModal({
  isVisible,
  onClose,
  rouletteData,
}: WinPrizeModalProps) {
  const pulseAnim = useRef(new Animated.Value(1)).current;

  // Efeito de pulsar
  useEffect(() => {
    if (isVisible) {
      const pulseAnimation = Animated.loop(
        Animated.sequence([
          Animated.timing(pulseAnim, {
            toValue: 1.1,
            duration: 1000,
            useNativeDriver: true,
          }),
          Animated.timing(pulseAnim, {
            toValue: 1,
            duration: 1000,
            useNativeDriver: true,
          }),
        ]),
      );
      pulseAnimation.start();
    }
  }, [isVisible, pulseAnim]);

  const handleCopyCoupon = useCallback(async () => {
    if (rouletteData?.premio) {
      try {
        await Clipboard.setString(rouletteData.premio);
        Alert.alert(
          'Desconto copiado!',
          'O código do desconto foi copiado para a área de transferência.',
        );
      } catch (error) {
        Alert.alert('Erro', 'Não foi possível copiar o desconto.');
      }
    }
  }, [rouletteData?.premio]);

  if (!rouletteData) return null;

  return (
    <Modal
      isVisible={isVisible}
      onBackdropPress={onClose}
      onBackButtonPress={onClose}>
      <ModalContainer>
        <ModalBackground
          source={require('../../../../assets/images/roleta/modal-backgroud.webp')}
          resizeMode="cover"
        />
        <ModalContent>
          <CloseModalIconButton onPress={onClose}>
            <CloseIcon name="x" />
          </CloseModalIconButton>
          <ModalBody>
            {rouletteData.tipo === 'desconto' && (
              // Layout para Cupom
              <>
                {/* Imagem do prêmio cupom */}
                <View
                  style={{alignItems: 'center', paddingTop: RFValue(40), paddingBottom: RFValue(20)}}>
                  <Animated.View
                    style={{
                      transform: [{scale: pulseAnim}],
                    }}>
                    <PrizeImage
                      source={require('../../../../assets/images/roleta/premio-cupom.webp')}
                      resizeMode="contain"
                    />
                  </Animated.View>
                </View>
                <ModalTitle>PARABÉNS!</ModalTitle>
                <ModalText>
                  {rouletteData?.message || 'Você ganhou um cupom de desconto!'}
                </ModalText>

                {/* Cupom Code */}
                {rouletteData?.premio && (
                  <CouponContainer>
                    <CouponContent>
                      <CouponLeftSide>
                        <CouponDiscount>tete</CouponDiscount>
                        <CouponMaxValue>DESCONTO EXCLUSIVO</CouponMaxValue>
                        <CouponDescription>
                          Use este cupom em sua próxima compra
                        </CouponDescription>
                      </CouponLeftSide>
                      <CouponRightSide onPress={handleCopyCoupon}>
                        <CouponBrand>CLIQUE AQUI</CouponBrand>
                        <CouponExpiry>para copiar</CouponExpiry>
                      </CouponRightSide>
                    </CouponContent>
                  </CouponContainer>
                )}
              </>
            )}
            {rouletteData.tipo === 'baratinha' && (
              // Layout para BaratinhaZ
              <>
                {/* Imagem do prêmio moeda */}
                <View
                    style={{alignItems: 'center', paddingTop: RFValue(40), paddingBottom: RFValue(20)}}>
                  <Animated.View
                    style={{
                      transform: [{scale: pulseAnim}],
                    }}>
                    <PrizeImage
                      source={require('../../../../assets/images/roleta/premio-moeda.webp')}
                      resizeMode="contain"
                    />
                  </Animated.View>
                </View>

                <ModalTitle>PARABÉNS!</ModalTitle>
                {rouletteData?.message && (
                  <ModalText>{rouletteData.message}</ModalText>
                )}

                {rouletteData?.premio && (
                  <ModalText
                    style={{
                      fontSize: 24,
                      fontWeight: 'bold',
                      textAlign: 'center',
                      color: '#FFD700',
                    }}>
                    {rouletteData.premio} BTZ
                  </ModalText>
                )}
              </>
            )}
            {!rouletteData.premio && (
              <>
                <View
                  style={{alignItems: 'center', paddingTop: RFValue(40), paddingBottom: RFValue(20)}}>
                  <Animated.View
                    style={{
                      transform: [{scale: pulseAnim}],
                    }}>
                    <PrizeImage
                      source={require('../../../../assets/images/roleta/caixa-vazia.webp')}
                      resizeMode="contain"
                    />
                  </Animated.View>
                </View>
                <ModalTitle>Não foi dessa vez!</ModalTitle>
                <ModalText>{rouletteData.message}</ModalText>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            {rouletteData?.tipo === 'desconto' ? (
              <Button title="Fechar" enabled onPress={onClose} />
            ) : (
              <Button title="Continuar" enabled onPress={onClose} />
            )}
          </ModalFooter>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
}
